module.exports = __webpack_public_path__ + "static/img/zhuanjie2.6d23aa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zhuanjie2.png
// module id = WhCN
// module chunks = 24